module.exports = __webpack_public_path__ + "static/media/client_detail_img1.d91e2270.jpg";